import { getSpriteFromType } from './helpers/ActionHelper'
import { ease, Easing } from './helpers/EaseHelper'
import { ACTION_ROPE, ACTION_ROPE_LARGE } from './Action'
/**
 * class Timeline
 */
class Timeline {
  /**
   * constructor
   */
  constructor () {
    this.el = null
    this.sprite = null
    this.cursor = null
    this.drag = null
    this.speed = 0
    this.ratio = 0
    this.previousRatio = 0
    this.distance = 0
    this.width = 0
    this.height = 0
    this.loopTimeoutId = null
    this.tweenRatio = 0
    this.tween = ease(this)
      .to({tweenRatio: 1}, 800)
      .delay(this.mouseOverFlag ? 0 : 1000)
      .easing(Easing.Cubic.InOut)
      .onUpdate(o => {
        if (this.mouseOverFlag) {
          this.cursor.style.left = '-50px'
          this.cursor.style.top = '-10px'
        } else {
          this.cursor.style.left = (-50 + this.tweenRatio * this.width) + 'px'
          this.cursor.style.top = (-10 - this.tweenRatio * this.height) + 'px'
        }
      })
      .onComplete(o => {
        this.cursor.style.opacity = 0
        this.startLoop()
      })
    this.mouseOverFlag = false
    this.onMouseOver = e => this.beforeDrag(e)
    this.onMouseOut = e => this.cancelDrag(e)
    this.onMouseDown = e => this.startDrag(e)
    this.onMouseMove = e => this.draging(e)
    this.onMouseUp = e => this.stopDrag(e)
    this.updateCallback = () => {}
    this.completeCallback = () => {}
  }

  clamp (min, value, max) { return Math.max(Math.min(value, max), min) }

  getTimelineInitialWidth () { return this.sprite.offsetWidth }

  enableCursor (visible) {
    if (visible) {
      document.body.removeAttribute('style')
      this.el.removeAttribute('style')
    } else {
      document.body.style.cursor = 'none'
      this.el.style.cursor = 'none'
    }
  }

  startLoop () {
    if (this.loopTimeoutId) clearTimeout(this.loopTimeoutId)
    this.tweenRatio = 0
    this.loopTimeoutId = setTimeout(() => {
      this.cursor.style.left = (-50 + this.tweenRatio * this.width) + 'px'
      this.cursor.style.top = (-10 - this.tweenRatio * this.height) + 'px'
      this.cursor.style.opacity = 1
      this.tween.start()
    }, this.mouseOverFlag ? 500 : 2000)
  }

  stopLoop () {
    this.cursor.style.opacity = 1
    this.tween.stop()
    clearTimeout(this.loopTimeoutId)
  }

  setTimeline(el, type, cursor, onUpdate, onComplete) {
    clearTimeout(this.loopTimeoutId)
    this.el = el
    this.sprite = getSpriteFromType(type)
    this.cursor = cursor
    this.width = this.getTimelineInitialWidth()
    this.height = (type === ACTION_ROPE || type === ACTION_ROPE_LARGE) ? 20 : 0
    this.completeCallback = onComplete
    this.updateCallback = onUpdate
    this.el.appendChild(this.sprite)
    this.el.addEventListener('mouseover', this.onMouseOver)
    this.el.addEventListener('mouseout', this.onMouseOut)
    this.el.addEventListener('mousedown', this.onMouseDown)
    this.el.addEventListener('touchstart', () => this.distance = 1000)
  }

  beforeDrag (e) {
    this.mouseOverFlag = true
  }

  cancelDrag (e) {
    this.enableCursor(true)
    this.mouseOverFlag = false
  }

  startDrag (e) {
    this.drag = e.clientX
    this.speed = 0
    this.ratio = 0
    this.distance = 0
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.onMouseUp)
    this.enableCursor(false)
    this.stopLoop()
  }

  draging (e) {
    this.speed += e.clientX - this.drag
    this.drag = e.clientX
  }

  stopDrag (e) {
    this.drag = null
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('mouseup', this.onMouseUp)
    this.enableCursor(true)
    this.cursor.style.opacity = 0
    this.startLoop()
  }

  onComplete () {
    this.stopDrag()
    this.stopLoop()
    this.el.removeEventListener('mousedown', this.onMouseDown)
    this.el.removeEventListener('mouseout', this.onMouseOut)
    this.completeCallback()
    this.el = null
    this.sprite = null
    this.cursor = null
    this.drag = null
    this.speed = 0
    this.ratio = 0
    this.previousRatio = 0
    this.distance = 0
    this.width = 0
    this.loopTimeoutId = null
    this.tweenRatio = 0
    this.completeCallback = () => {}
    this.updateCallback = () => {}
    this.completeCallback = () => {}
  }

  update (time, delta) {
    if (!this.el) return
    this.distance = this.clamp(0, this.distance + this.speed, this.width)
    this.ratio = this.clamp(0, this.distance / this.width, 1)
    if (this.width <= 0) {
      this.width = this.getTimelineInitialWidth()
    } else {
      this.sprite.updateRatio(this.ratio)
    }
    if (this.drag === null) {
      if (this.ratio >= 1) {
        this.onComplete()
        return
      }
      this.distance = Math.floor(this.distance * 80) / 100
      this.speed = Math.floor(this.speed * 20) / 100
    } else {
      this.speed = 0
    }
    if (this.ratio > 0) {
      this.cursor.style.left = (-50 + this.ratio * this.width) + 'px'
      this.cursor.style.top = (-10 - this.ratio * this.height) + 'px'
      if (this.previousRatio !== this.ratio) this.updateCallback(this.ratio)
      this.previousRatio = this.ratio
    }
  }
}
export default Timeline


// WEBPACK FOOTER //
// ./src/scripts/Timeline.js